import { useEffect, useRef, useState } from 'react';

export const useTimeout = (time: number): boolean => {
  const timeout = useRef<ReturnType<typeof setTimeout>>();
  const [resolved, setResolved] = useState(false);

  useEffect(() => {
    timeout.current = setTimeout(() => setResolved(true), time);

    return () => {
      timeout.current && clearTimeout(timeout.current);
    };
  });

  return resolved;
};
